import { render, staticRenderFns } from "./MultipleChoiceText.vue?vue&type=template&id=aec4f17c&"
import script from "./MultipleChoiceText.vue?vue&type=script&lang=js&"
export * from "./MultipleChoiceText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/jeffreymb/BibleLing/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aec4f17c')) {
      api.createRecord('aec4f17c', component.options)
    } else {
      api.reload('aec4f17c', component.options)
    }
    module.hot.accept("./MultipleChoiceText.vue?vue&type=template&id=aec4f17c&", function () {
      api.rerender('aec4f17c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/MultipleChoiceText.vue"
export default component.exports